import axios from "axios";
import React, { useEffect, useState } from "react";
import { Button, Form, Row, Col, Card } from "react-bootstrap";
import { useUnsavedChanges } from "./UnsavedChangesContext";

const VitalsChecklistModal = ({
  masterVitals = [],
  prescriptionId,
  selectedVitals = [],
  setVitals,
  vitals,
  validateVitalsParent
}) => {

  const [errors, setErrors] = useState({});
  const {setIsDirty } = useUnsavedChanges();

  const activeIds = vitals
    .filter(v => v.is_active !== 0)
    .map(v => v.vital_sign_id);

  const validateAllVitals = () => {
    let newErrors = {};
    let isValid = true;

    vitals.forEach((vital, index) => {
      if (vital.is_active === 1) {
        if (vital.threshold_min === "" || vital.threshold_min === null) {
          newErrors[`min-${index}`] = "Required";
          isValid = false;
        }
        if (vital.threshold_max === "" || vital.threshold_max === null) {
          newErrors[`max-${index}`] = "Required";
          isValid = false;
        }

        if (vital.threshold_min_2 !== null) {
          if (vital.threshold_min_2 === "") {
            newErrors[`min2-${index}`] = "Required";
            isValid = false;
          }
        }

        if (vital.threshold_max_2 !== null) {
          if (vital.threshold_max_2 === "") {
            newErrors[`max2-${index}`] = "Required";
            isValid = false;
          }
        }
      }
    });

    setErrors(newErrors);
    return isValid;
  };

  // useEffect(() => {
  //   if (selectedVitals?.length) {
  //     setVitals(selectedVitals);
  //   }
  // }, [selectedVitals]);

  const handleSelectVital = (e) => {
    const id = Number(e.target.value);
    const vital = masterVitals.find((v) => v.id === id);
    if (!vital) return;

    const newVital = {
      vital_sign_id: vital.id,
      is_active: 1,
      threshold_min: Number(vital.min_value),
      threshold_max: Number(vital.max_value),
      threshold_min_2: vital.min_value_2 ? Number(vital.min_value_2) : null,
      threshold_max_2: vital.max_value_2 ? Number(vital.max_value_2) : null
    };

  // setVitals((prev) => {
  //   const exists = prev.some((v) => v.vital_sign_id === vital.id);
  //   if (exists) return prev;
  //   return [...prev, newVital];
  // });

  setVitals((prev) => {
    const existingIndex = prev.findIndex(
      (v) => v.vital_sign_id === vital.id
    );

    // If already exists but inactive → reactivate
    if (existingIndex !== -1) {
      const updated = [...prev];
      updated[existingIndex].is_active = 1;
      return updated;
    }
    // New entry
    return [...prev, newVital];
  });
};

  const handleChange = (index, field, value) => {
    if (!/^\d*\.?\d*$/.test(value)) return;
    const updated = [...vitals];
    updated[index][field] = value === "" ? "" : Number(value);
    setVitals(updated);
    setIsDirty(true);
  };

// const handleRemove = (index) => {
//   const updated = [...vitals];
//   updated[index] = {
//     ...updated[index],
//     is_active: 0
//   };
//   setVitals(updated);
// };

// const handleSave = async () => {
//   const payload = {
//     prescription_id: prescriptionId,
//     vital_signs: vitals
//   };

//   const tokenStr = localStorage.getItem("accessToken");

//   const { data } = await axios.post(
//     `${process.env.REACT_APP_SERVER_URL}/prescriptions/set-prescription-vital-signs`,
//     payload,
//     {
//       headers: { Authorization: `Bearer ${tokenStr}` }
//     }
//   );

//   if (data.status) {
//     alert("Vitals saved successfully");
//   }
// };

const getVitalLabels = (master) => {
  if (!master) return {};

  switch (master.short_name) {
    case "BP":
      return {
        min: "Systolic Min (mmHg)",
        max: "Systolic Max (mmHg)",
        min2: "Diastolic Min (mmHg)",
        max2: "Diastolic Max (mmHg)"
      };

    case "Temp":
      return {
        min: "Min Temperature",
        max: "Max Temperature"
      };

    case "Pulse":
      return {
        min: "Min Pulse",
        max: "Max Pulse"
      };

    case "Weight":
      return {
        min: "Min Weight",
        max: "Max Weight"
      };

    case "Resp":
      return {
        min: "Min Respiration",
        max: "Max Respiration"
      };

    case "BS":
      return {
        min: "Min Blood Sugar",
        max: "Max Blood Sugar"
      };

    case "O2":
      return {
        min: "Min O₂ Saturation",
        max: "Max O₂ Saturation"
      };

    case "Pain":
      return {
        min: "Min Pain Score",
        max: "Max Pain Score"
      };

    default:
      return {
        min: `Min (${master.unit})`,
        max: `Max (${master.unit})`
      };
  }
};


const handleNumberInput = (value) => {
    // Allow only digits and one decimal point
    if (/^\d*\.?\d*$/.test(value)) {
      return value;
    }
    return null;
  };

useEffect(() => {
  if (validateVitalsParent) {
    validateAllVitals();
  }
}, [validateVitalsParent]);


return (
  <div>
      {masterVitals.map((master, idx) => {
        const vitalIndex = vitals.findIndex(
          (v) => v.vital_sign_id === master.id
        );

        const vital = vitals[vitalIndex];
        const isActive = vital?.is_active === 1;

        const labels = getVitalLabels(master);

        const handleToggle = (checked) => {
          if (vitalIndex !== -1) {
            const updated = [...vitals];
            updated[vitalIndex].is_active = checked ? 1 : 0;
            setVitals(updated);
          } else if (checked) {
            const newVital = {
              vital_sign_id: master.id,
              is_active: 1,
              threshold_min: Number(master.min_value),
              threshold_max: Number(master.max_value),
              threshold_min_2: master.min_value_2
                ? Number(master.min_value_2)
                : null,
              threshold_max_2: master.max_value_2
                ? Number(master.max_value_2)
                : null
            };

            setVitals((prev) => [...prev, newVital]);
          }
        };

        return (
          <div
            key={master.id}
            className={`px-3 py-2 ${idx !== masterVitals.length - 1 ? "border-bottom" : ""}`}
          >
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <span className="fw-semibold">{master.name}</span>
                <span className="text-muted ms-2">
                  ({master.unit || "N/A"})
                </span>
              </div>

              <Form.Check
                type="switch"
                checked={isActive}
                onChange={(e) => {
                  handleToggle(e.target.checked);
                  setIsDirty(true);
                }}
              />
            </div>
            {isActive && (
              <div className="mt-3">

                <Row className="mb-2">
                  <Col>
                    <Form.Group>
                      <Form.Label>{labels.min}</Form.Label>
                      <Form.Control
                        type="text"
                        size="sm"
                        value={vital?.threshold_min ?? ""}
                        isInvalid={!!errors[`min-${vitalIndex}`]}
                        onChange={(e) =>
                          handleChange(
                            vitalIndex,
                            "threshold_min",
                            e.target.value
                          )
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors[`min-${vitalIndex}`]}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col>
                    <Form.Group>
                      <Form.Label>{labels.max}</Form.Label>
                      <Form.Control
                        type="text"
                        size="sm"
                        value={vital?.threshold_max ?? ""}
                        isInvalid={!!errors[`max-${vitalIndex}`]}
                        onChange={(e) =>
                          handleChange(
                            vitalIndex,
                            "threshold_max",
                            e.target.value
                          )
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors[`max-${vitalIndex}`]}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>

                {master.data_type === "dual" && (
                  <Row>
                    <Col>
                      <Form.Group>
                        <Form.Label>{labels.min2}</Form.Label>
                        <Form.Control
                          type="text"
                          size="sm"
                          value={vital?.threshold_min_2 ?? ""}
                          isInvalid={!!errors[`min2-${vitalIndex}`]}
                          onChange={(e) =>
                            handleChange(
                              vitalIndex,
                              "threshold_min_2",
                              e.target.value
                            )
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors[`min2-${vitalIndex}`]}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col>
                      <Form.Group>
                        <Form.Label>{labels.max2}</Form.Label>
                        <Form.Control
                          type="text"
                          size="sm"
                          value={vital?.threshold_max_2 ?? ""}
                          isInvalid={!!errors[`max2-${vitalIndex}`]}
                          onChange={(e) =>
                            handleChange(
                              vitalIndex,
                              "threshold_max_2",
                              e.target.value
                            )
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors[`max2-${vitalIndex}`]}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>
                )}
              </div>
            )}
          </div>
        );
      })}
  </div>
);
};

export default VitalsChecklistModal;